/* ============================================================
   NeoSpherium · device-saved wishlist (localStorage).
   Heart toggles on product cards + PDP; nav heart count; a /pages/wishlist
   page renders the saved items from window.NSWishlist.read(). No account
   needed (per-device); upgrades to account-sync when Customer Accounts ship.
   Stores a small snapshot per item so the wishlist page renders without fetches.
   ============================================================ */
(function () {
  var KEY = 'ns-wishlist';

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('ns-wishlist:change', { detail: { count: list.length } }));
  }
  /* 16 Oct 2026: a listing shows one card per colorway, so a listing heart carries data-wish-colour and its saved state
     follows that colorway: saving the Black card no longer fills the White card's heart. A heart with no colour (the
     product page, search, home, the wishlist page) and a save made before this change still match on the product id
     alone, exactly as before. */
  function same(x, id, col) { return String(x.id) === String(id) && (!col || !x.colour || x.colour === col); }
  function has(id, col) { return read().some(function (x) { return same(x, id, col || ''); }); }
  function remove(id, col) { write(read().filter(function (x) { return !same(x, id, col || ''); })); }
  function toggle(item) {
    var list = read(), col = item.colour || '', k;
    /* a colourless heart that names a saved variant (a wishlist-page card) removes that one save, not the product's other colours */
    if (!col && item.variant) {
      for (k = 0; k < list.length; k++) {
        if (String(list[k].id) === String(item.id) && String(list[k].variant || '') === String(item.variant)) { list.splice(k, 1); write(list); return false; }
      }
    }
    var keep = list.filter(function (x) { return !same(x, item.id, col); });
    if (keep.length < list.length) { write(keep); return false; }
    list.unshift(item);
    write(list);
    return true; // true => now saved
  }

  function itemFromHeart(h) {
    return {
      id: h.getAttribute('data-wish-id'),
      colour: h.getAttribute('data-wish-colour') || '',
      title: h.getAttribute('data-wish-title') || '',
      url: h.getAttribute('data-wish-url') || '',
      image: h.getAttribute('data-wish-image') || '',
      price: h.getAttribute('data-wish-price') || '',
      vendor: h.getAttribute('data-wish-vendor') || '',
      variant: h.getAttribute('data-wish-variant') || '',
      handle: h.getAttribute('data-wish-handle') || ''
    };
  }

  /* 16 Oct 2026, Arabic slice 1: the heart's label comes from the locale (window.NS_WISH_I18N, written by the theme);
     the English words are only the fallback when a page has not defined it. */
  function label(on) {
    var t = window.NS_WISH_I18N || {};
    return on ? (t.remove || 'Remove from wishlist') : (t.save || 'Save to wishlist');
  }

  function paintHeart(h) {
    var on = has(h.getAttribute('data-wish-id'), h.getAttribute('data-wish-colour') || '');
    h.classList.toggle('is-saved', on);
    h.setAttribute('aria-pressed', on ? 'true' : 'false');
    h.setAttribute('aria-label', label(on));
  }
  function syncHearts(scope) { (scope || document).querySelectorAll('.wish-heart').forEach(paintHeart); }

  function updateCount() {
    var n = read().length;
    document.querySelectorAll('[data-wish-count]').forEach(function (el) {
      el.textContent = n; el.hidden = n === 0;
    });
  }

  function onHeart(h) {
    var nowSaved = toggle(itemFromHeart(h));
    h.classList.toggle('is-saved', nowSaved);
    h.setAttribute('aria-pressed', nowSaved ? 'true' : 'false');
    h.setAttribute('aria-label', label(nowSaved));
    // gentle pop
    h.classList.remove('wish-pop'); void h.offsetWidth; h.classList.add('wish-pop');
  }

  function bind(scope) {
    (scope || document).querySelectorAll('.wish-heart').forEach(function (h) {
      if (h.dataset.wishBound) return; h.dataset.wishBound = '1';
      h.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); onHeart(h); });
      h.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); onHeart(h); }
      });
    });
  }

  function init() { bind(); syncHearts(); updateCount(); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); syncHearts(e.target); });
  document.addEventListener('ns-wishlist:change', function () { updateCount(); syncHearts(); });

  window.NSWishlist = { read: read, has: has, toggle: toggle, remove: remove, bind: bind, syncHearts: syncHearts };
})();
